// @flow

import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import { useTransition, animated } from 'react-spring';
import { useSelector, useDispatch } from 'react-redux';
import CropTool from './CropTool';

function Modal() {
  const isOpen = useSelector(state => state.modal);
  const transitions = useTransition(isOpen, null, {
    from: { marginTop: '-50%', bg: 'rgba(0,0,0,0)' },
    enter: { marginTop: '0%', bg: 'rgba(0,0,0,.8)' },
    leave: { marginTop: '150%', bg: 'rgba(0,0,0,0)' },
  });

  return ReactDOM.createPortal(
    <React.Fragment>
      {transitions.map(({ item, key, props }) => item &&
        <animated.aside key={key} style={ {backgroundColor: props.bg} } aria-modal="true" tabIndex="-1" className="modal__background">
          <animated.div className="modal__box" style={ {marginTop: props.marginTop, maxWidth: 1024, maxHeight: 800, padding: 20} }>
            <CropTool />
          </animated.div>
      </animated.aside>
    )}
  </React.Fragment>, document.body)
}

export default Modal;
